
import React from "react";
import { DownloadHeader } from "./DownloadHeader";
import { VideoSelectionControls } from "./VideoSelectionControls";
import { DownloadStatus } from "./DownloadStatus";
import { calculateVideoStats } from "@/utils/videoHelpers";
import { TikTokVideo } from "@/types/api";

interface DownloadContainerProps {
  videos: TikTokVideo[];
  selected: string[];
  onSelectAll: (selectAll: boolean) => void;
  isDownloading: boolean;
  collectionUrl: string;
  viewMode: 'grid' | 'table';
  onViewModeChange: (mode: 'grid' | 'table') => void;
  onDownloadAll: () => void;
}

export function DownloadContainer({
  videos,
  selected,
  onSelectAll,
  isDownloading,
  collectionUrl,
  viewMode,
  onViewModeChange,
  onDownloadAll
}: DownloadContainerProps) {
  const videoStats = calculateVideoStats(videos);

  return (
    <div className="bg-[#111827] rounded-lg border border-gray-800 p-4 mb-4">
      <DownloadHeader 
        videos={videos} 
        collectionUrl={collectionUrl} 
        onDownloadAll={onDownloadAll}
        disabled={isDownloading}
        selected={selected}
      />
      <VideoSelectionControls
        selected={selected}
        onSelectAll={onSelectAll}
        isDownloading={isDownloading}
        totalVideos={videos.length}
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        onDownloadAll={onDownloadAll}
      />
      <DownloadStatus
        selected={selected}
        videoStats={videoStats}
      />
    </div>
  );
}
